import { render } from "./QuickLinks.vue?vue&type=template&id=1b074035&scoped=true&ts=true"
import script from "./QuickLinks.vue?vue&type=script&lang=ts"
export * from "./QuickLinks.vue?vue&type=script&lang=ts"

import "./QuickLinks.vue?vue&type=style&index=0&id=1b074035&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b074035"]])

export default __exports__